// React
import React, { Component } from "react";
// Translations
import { withTranslation } from "react-i18next";

class View extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        const { billing } = this.props;
        return (
            <React.Fragment>
                 <div style={{ marginTop: 20 }}>
                    <span>{billing.name}</span>
                    <span>{billing.lastname}</span>
                    <span>{billing.dni}</span>
                </div>
                <div style={{ marginBottom: 20 }}>
                    <span>{billing.company}</span>
                    <span>{billing.cif_nif}</span>
                </div>
                <div>
                    <span>{billing.address}</span>
                    <span>{billing.floor}</span>
                    <span>{billing.door}</span>
                </div>
                <div>
                    <span>{billing.email}</span>
                    <span>{billing.phone}</span>
                </div>
                <div>
                    <span>{billing.country}</span>
                    {
                        billing.country === "Spain" &&
                        <span>{billing.city}</span>
                    }
                    <span>{billing.postal_code}</span>
                </div>
            </React.Fragment>
        );
    }
}

export default withTranslation("billing")(View);